<script lang="ts" setup>
import { ref } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import icon from '@core/assets/image/im/icon-image.svg';
import ActionBtn from './ActionBtn.vue';
import { ImageActionService } from './ImageAction.service';

const imageActionService = useService(ImageActionService);

const props = defineProps({
  sendImage: {
    type: Function,
    required: true,
  },
});

const fileInput = ref<HTMLInputElement | null>(null);

function handleFileUpload(event: Event) {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (file) {
    // 处理文件上传逻辑
    console.log('Selected file:', file);
    props.sendImage(file);
  }
}
// 打开文件选择器
function openFilePicker() {
  if (fileInput.value) {
    fileInput.value.click();
  }
}
</script>

<template>
  <ActionBtn
    v-track:oj_click_im_window_image.click
    :icon="icon"
    text="发图片"
    @click="openFilePicker"
  />
  <input
    ref="fileInput"
    type="file"
    accept="image/*"
    style="display: none"
    @change="handleFileUpload"
  />
</template>
